import { Form } from "react-bootstrap";

const InputRangoFecha = ({ setFiltros }) => {
  return (
    <>
      <div className="d-flex flex-column">
        {/* <h5 className="m-0 text-center" style={{fontSize:"1rem"}}>Rango de fecha</h5> */}
        <div className="d-flex gap-3">
          <Form.Group>
            <Form.Label className="m-0 text-center w-100" style={{ fontSize: "0.8rem" }}>
              Fecha Desde
            </Form.Label>
            <Form.Control
              type="date"
              onChange={(e) => {
                setFiltros((prevState) => ({
                  ...prevState,
                  fecha_desde: e.target.value,
                }));
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="m-0 text-center w-100" style={{ fontSize: "0.8rem" }}>
              Fecha Hasta
            </Form.Label>
            <Form.Control
              type="date"
              onChange={(e) => {
                setFiltros((prevState) => ({
                  ...prevState,
                  fecha_hasta: e.target.value,
                }));
              }}
            />
          </Form.Group>
        </div>
      </div>
    </>
  );
};
export default InputRangoFecha;
